import React from 'react';
import styled from 'styled-components';

const Navbar = ({ children }) => (
    <NavbarContainer>
        <NavbarInner>{children}</NavbarInner>
    </NavbarContainer>
);

export default Navbar;

const NavbarContainer = styled.div`
    z-index: 500;
    position: fixed;
    background: white;
    width: 100%;
    height: ${({ theme }) => theme.navbar.med};
    border-bottom: 1px solid ${props => props.theme.color.scLightGray3};
    /* box-shadow: 0 0px 4px #0003; */

    @media (max-width: ${({ theme }) => theme.width.lrg}) {
        height: ${({ theme }) => theme.navbar.med};
    }
`;

const NavbarInner = styled.div`
    /* width: ${props => props.theme.width.lrg}; */
    max-width: 100%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const NavHalf = styled.div`
    height: 100%;
    max-height: 100%;
    flex: ${({ flex }) => flex ? flex : '1'} 0 0%;
    display: flex;
    justify-content: ${props => (props.justify || 'flex-start')};
    align-items: center;
    box-sizing: border-box;
`;

const NavOptionContainer = styled.div`
    /* font-family: 'Open Sans Condensed'; */
    font-size: 16px;
    white-space: nowrap;
    height: 100%;
    padding: 0 20px;
    margin: ${({ login }) => login ? '0 20px' : 'none'};
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${props => (props.active ? props.theme.color.primary : props.theme.color.scDarkGray3)};
    border-bottom: 3px solid ${props => (props.active ? props.theme.color.primary : 'white')};
    background-color: #FFF;
    transition: 0.2s;

    &:hover {
        background-color: ${props => props.theme.color.primary} !important;
        border-bottom: 3px solid ${props => props.theme.color.primary};
        color: white !important;
        cursor: pointer;
    }

    &:active {
        background-color: ${props => props.theme.color.secondary} !important;
        border-bottom: 3px solid ${props => props.theme.color.secondary};
    }
`;

export const NavOption = ({
    routeName, pathName, currPath, history, login
}) => (
        <NavOptionContainer
            active={currPath.includes(pathName)}
            onClick={() => history.push(pathName)}
            login={login}
        >
            {routeName}
        </NavOptionContainer>
    );

export const NavbarLink = styled.a`
    margin-left: 20px;
    box-sizing: border-box;
    font-size: ${props => props.theme.font.xs};
`;



// WEBPACK FOOTER //
// ./src/sc-ui/Navbar.jsx